import styled from 'styled-components';
import {device} from '../../styled/device';
import {Col} from '../../views/ExperiencesPage/ModalReceiveTicket/styled';
import {Button} from '../Button';

export const ModalHeader = styled(Col)`
  display: flex;
  flex-direction: column;
  text-align: center;

  .desktopImage {
    padding-bottom: 15px;
  }

  .modalTitle {
    font-family: Poppins-Regular, sans-serif;
    font-size: 30px;
    font-weight: 400;
    color: #23262f;
    margin-bottom: 10px;
  }

  .modalMobileTitle {
    display: none;
  }

  .modalSubTitle {
    font-family: Poppins-Regular, sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #777e90;
    padding-bottom: 30px;
  }

  @media (max-width: ${device.mobileM}) {
    .desktopImage {
      display: none;
    }

    .modalTitle {
      display: none;
    }

    .modalMobileTitle {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
      font-size: 30px;
      font-weight: 400;
      color: #23262f;
      padding-bottom: 20px;
    }

    .modalSubTitle {
      font-size: 18px;
    }
  }
`;

export const ModalTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalContent = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 40px;

  @media (max-width: ${device.mobileXL}) {
    padding: 0;
  }
`;

export const ModalSecondaryButton = styled.div`
  display: flex;
  align-items: center;
`;

export const ModalSummaryItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 12px 0;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  padding: 50px 0 0;
`;

export const ModalButton = styled(Button)`
  width: 220px;
  height: 52px;
  justify-content: initial;
`;

export const ModalSummaryCol = styled.div`
  display: flex;
  column-gap: 9px;
  font-family: Poppins-Regular, sans-serif;
  color: #777e90;

  & > small {
    margin-right: 10px;
  }
  align-items: center;
  text-align: left;
`;

export const ModalSummaryColSecond = styled(ModalSummaryCol)`
  font-family: Poppins-Medium, sans-serif;
  color: #23262f;
  text-align: right;
  margin-left: 20px;
`;

export const CheckIcon = styled.img`
  margin: 0 10px 1px 0;
`;
